<template>
    <button class="navbar-toggler" :class="{ 'is-open': toggled }" type="button"
            data-toggle="collapse"
            :data-target="target"
            :aria-controls="target"
            :aria-expanded="toggled"
            aria-label="Toggle navigation">
        <span class="menu-icon" aria-hidden="true">
            <span></span>
            <span></span>
            <span></span>
        </span>
    </button>
</template>
<script>
export default {
  props: {
    target: {
      type: [String, Number],
      description: "Button target element"
    },
    toggled: {
      type: Boolean,
      default: false,
      description: "Whether button is toggled"
    }
  }
};
</script>
<style scoped>
.navbar-toggler {
  display: inline-flex;
  width: 46px;
  height: 42px;
  align-items: center;
  justify-content: center;
  padding: 0 !important;
  color: #ffffff !important;
  border: 1px solid rgba(230, 203, 114, 0.4) !important;
  border-radius: 12px;
  background: rgba(6, 47, 54, 0.58) !important;
  box-shadow: 0 8px 20px rgba(45, 54, 45, 0.12),
    inset 0 1px 0 rgba(230, 203, 114, 0.12);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  transition: transform 0.2s ease, border-color 0.2s ease,
    background-color 0.2s ease, box-shadow 0.2s ease;
}

.navbar-toggler:hover,
.navbar-toggler:focus-visible {
  border-color: var(--bjp-gold-200) !important;
  background: rgba(230, 203, 114, 0.12) !important;
  box-shadow: 0 10px 24px rgba(0, 15, 30, 0.28),
    0 0 0 3px rgba(240, 211, 110, 0.12);
  outline: none;
  transform: translateY(-1px);
}

.menu-icon {
  display: flex;
  width: 24px;
  height: 16px;
  flex-direction: column;
  justify-content: space-between;
}

.menu-icon span {
  display: block;
  width: 100%;
  height: 2px;
  border-radius: 999px;
  background: var(--bjp-gold-400);
  box-shadow: none;
  transform-origin: center;
  transition: transform 0.25s ease, opacity 0.2s ease;
}

.navbar-toggler.is-open .menu-icon span:first-child {
  transform: translateY(7px) rotate(45deg);
}

.navbar-toggler.is-open .menu-icon span:nth-child(2) {
  opacity: 0;
  transform: scaleX(0);
}

.navbar-toggler.is-open .menu-icon span:last-child {
  transform: translateY(-7px) rotate(-45deg);
}

@media (prefers-reduced-motion: reduce) {
  .navbar-toggler,
  .menu-icon span {
    transition: none;
  }
}
</style>
